// components/DateOfBirthInput.jsx
import { useState, useRef } from 'react';
import { useField, useFormikContext } from 'formik';
import { DayPicker } from 'react-day-picker';
import { IconCalendar } from '@tabler/icons-react';
import { format } from 'date-fns';
import useClickOutside from 'lib/hooks/useClickOutside';

export default function DateOfBirthInput({ name, label = 'DATE OF BIRTH' }) {
  const dropdownRef = useRef();
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const [open, setOpen] = useState(false);

  useClickOutside(dropdownRef, () => setOpen(false));

  const selectedDate = field.value ? new Date(field.value) : undefined;

  const handleSelect = (date) => {
    if (date) {
      const formatted = format(date, 'yyyy-MM-dd');
      setFieldValue(name, formatted);
      setOpen(false); // ✅ otomatis tutup setelah pilih tanggal
    }
  };

  const errorClass =
    'block w-full rounded-xl border-0 py-1.5 shadow-sm text-red-900 ring-1 ring-inset ring-red-300 placeholder:text-red-300 focus:ring-2 focus:ring-inset focus:ring-red-500 text-sm';
  const classInput =
    'block w-full rounded-xl border-0 py-1.5 shadow-sm text-kin-text font-regular ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-main text-sm disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200';

  return (
    <div className="flex-1" ref={dropdownRef}>
      {label && (
        <label className="block text-sm font-medium leading-6 text-kin-text">{label}</label>
      )}

      {/* Button yang membuka popup */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={`${
          meta.error ? errorClass : classInput
        } bg-white flex flex-row items-center gap-1 mt-1 px-3`}>
        <IconCalendar className="w-4 h-4" />
        {field.value ? <span>{field.value}</span> : <span>Select date</span>}
      </button>

      {/* Popup Date Picker */}
      {open && (
        <div className="relative">
          <div className="absolute bottom-10 z-20 mt-2 w-auto rounded-lg border bg-white shadow-lg">
            <DayPicker
              mode="single"
              selected={selectedDate}
              onSelect={handleSelect}
              captionLayout="dropdown-buttons"
              fromYear={1980}
              toYear={new Date().getFullYear()}
              modifiersClassNames={{
                selected: '!bg-primary-main !text-white',
                today: '!text-primary-main',
              }}
            />
          </div>
        </div>
      )}

      {/* Error & hint */}
      {meta.touched && meta.error && <div className="text-red-600 mt-1 text-sm">{meta.error}</div>}
    </div>
  );
}
